/**
 * Friday's note: why she built Grow, in her words, beside her photo.
 *
 * Her photo is public/landing/friday.jpg, cropped from the website's
 * fridayingarden.png (owner's choice, 2026-10-09), shown round beside the note.
 *
 * Words (en/es): landing.note.*, landing.slots.avatar.
 *
 * @module FridayNote
 */

import React from 'react';
import { useTranslation } from '@/shared/hooks/useTranslation';
import { PhotoSlot } from '../components/PhotoSlot';

/** Friday's note. */
export const FridayNote: React.FC = () => {
  const { reactTranslate: t } = useTranslation();
  return (
    <section className="bg-muted px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto flex max-w-3xl items-center gap-4">
        <PhotoSlot label={t('landing.slots.avatar')} src="/landing/friday.jpg" className="h-20 w-20 shrink-0 rounded-full md:h-24 md:w-24" />
        <div className="min-w-0 space-y-1.5">
          <p className="text-xl italic leading-snug md:text-2xl">&ldquo;{t('landing.note.quote')}&rdquo;</p>
          <p className="text-sm text-muted-foreground">{t('landing.note.byline')}</p>
        </div>
      </div>
    </section>
  );
};
